import { NomenclatureDTO } from '../dtoTypes'
import { Nomenclature } from '../types'

export const adaptNomenclatureDTO = (
    nomenclatureDTO: NomenclatureDTO,
): Nomenclature => ({
    id: nomenclatureDTO.id,
    name: nomenclatureDTO?.name ?? null,
    code: nomenclatureDTO.code,
    nomenclature_photo: {
        read_url: nomenclatureDTO.nomenclature_photo?.read_url ?? null,
        hash_name: nomenclatureDTO.nomenclature_photo?.hash_name ?? null,
    },
    type: nomenclatureDTO.type,
    count: nomenclatureDTO.count,
    price: nomenclatureDTO.price,
    comment: nomenclatureDTO.comment,
    areaId: nomenclatureDTO.area_id_id,
    totalEarned: nomenclatureDTO.total_earned,
    avgSalesPerDay: nomenclatureDTO.avg_sales_per_day,
})
